<template>
    <div class="shared-carousel-slide swiper-slide">
        <slot />
    </div>
</template>
